module.exports = __webpack_public_path__ + "static/media/id-pic.5cd20fe9.svg";